define('modules/accounts/status/view-no-service',['require','exports','module','views/BaseView','ldsh!./template-no-service'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var View = BaseView.extend({
        template: require("ldsh!./template-no-service"),
        initialize: function() {},
        serialize: function() {
            return {
                service: this.service
            };
        }
    });

    module.exports = View;
});

